export class DirectoryMissingRelationship {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "selectedEntityId",
            "baseName": "selectedEntityId",
            "type": "string",
            "format": ""
        },
        {
            "name": "selectedEntityType",
            "baseName": "selectedEntityType",
            "type": "DirectoryEntityType",
            "format": ""
        },
        {
            "name": "edgeType",
            "baseName": "edgeType",
            "type": "DirectoryEdgeType",
            "format": ""
        },
        {
            "name": "direction",
            "baseName": "direction",
            "type": "DirectoryEdgeDirection",
            "format": ""
        },
        {
            "name": "entityId",
            "baseName": "entityId",
            "type": "string",
            "format": ""
        },
        {
            "name": "entityType",
            "baseName": "entityType",
            "type": "DirectoryEntityType",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "recycleBinOnly",
            "baseName": "recycleBinOnly",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DirectoryMissingRelationship.attributeTypeMap;
    }
    constructor() {
    }
}
